module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-user"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.imgPath,
      "onerror": "this.src='/public/image/patient.png';this.onerror=null;"
    }
  })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.store.account.name))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'homepage'
      }
    }
  }, [_c('div', [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'caselist'
      }
    }
  }, [_c('div', [_vm._v("档案")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'evaluation'
      }
    }
  }, [_c('div', [_vm._v("测评")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'train'
      }
    }
  }, [_c('div', [_vm._v("训练体验")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'orderList'
      }
    }
  }, [_c('div', [_vm._v("居家康复")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-footer"
  }, [_c('li', {
    staticClass: "version",
    staticStyle: {
      "color": "#999",
      "font-weight": "400",
      "margin-bottom": "20px"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.weChat),
      expression: "weChat"
    }],
    staticStyle: {
      "position": "absolute",
      "bottom": "200px",
      "width": "147px",
      "height": "144px"
    },
    attrs: {
      "src": require("../../../assets/img/WeChat.png")
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "line-height": "24px"
    },
    attrs: {
      "href": "http://www.66nao.com/",
      "target": "_blanck"
    }
  }, [_vm._v("进入官网")]), _vm._v(" "), _c('button', {
    on: {
      "mouseover": _vm.showWeChat,
      "mouseout": _vm.hideWeChat
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('div', {
    staticClass: "see-log",
    on: {
      "click": _vm.seeLog
    }
  }, [_vm._v("Version:" + _vm._s(_vm.showVersion))]), _vm._v(" "), _c('div', {
    staticClass: "foot-flag"
  }, [_vm._v("2019"), _c('img', {
    attrs: {
      "src": require("../../../assets/img/logo_gray.png")
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.gName)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-604b3a10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/doc/leftmenu.vue
// module id = 995
// module chunks = 2